import React from 'react';

interface Props {
    children: React.ReactNode | React.ReactNode[]
    additionalStyles?: React.CSSProperties
}

const FormContainer = ({children, additionalStyles}: Props) => {
    return (
        <div style={{height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <div style={{
                maxWidth: '40em',
                width: '75%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                ...additionalStyles}}>
                {children}
            </div>
        </div>
    )
}

export default FormContainer;